import axios from 'axios';
import { parseAbsenceTypes } from '../converters/absenceTypeConverters';
import AbsenceType from '../models/AbsenceType';

export default class AbsenceTypeClient {
  static async loadAll(): Promise<Array<AbsenceType>> {
    const response = await axios.get('/api/mobopro/v1/absencetypes');
    return parseAbsenceTypes(response.data);
  }
}
